var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item && _vm.userType == 'B2B' && _vm.label_stock_availability !== false)?_c('div',{staticClass:"stock-av"},[_c('small',[_c('b',[_vm._v("\n      "+_vm._s(_vm.label_stock_availability)+"\n    ")])]),_vm._v(" "),_c('span',{staticClass:"status",class:_vm.stockStatusIcon}),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.stockStatusText))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }